import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ShopWindowItem } from "../../shared/model/shop-window-item";
import { DtmService } from 'src/app/services/dtm.service';
import { DialogAlertComponent } from 'src/app/shared/components/dialog-alert/dialog-alert.component';
import { DialogLoadingComponent } from 'src/app/shared/components/dialog-loading/dialog-loading.component';
import { LoadingComponent } from 'src/app/shared/components/loading/loading.component';
import { errorMapping, braspagReasonCode, adyenReasonCode, authReasonCode } from 'src/app/shared/constants/errors';
import { Dtm, getDtm } from 'src/app/shared/enum/dtm';
import { DialogData } from 'src/app/shared/model/dialog-data';
import { ProductChange } from 'src/app/shared/model/product-change';
import { CatalogService } from 'src/app/shared/services/catalog.service';
import { DiscountModalService } from 'src/app/shared/services/discount-modal.service';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';
import { CustomerService } from 'src/app/shared/services/customer.service';
import { Discount } from 'src/app/shared/model/discount';

@Component({
    selector: 'pme-change-plan',
    templateUrl: './change-plan.component.html',
    styleUrls: ['./change-plan.component.scss'],
    animations: [
        trigger("componentFade", [
            state("loaded", style({ opacity: 1 })),
            transition(":enter", [
                style({ opacity: 0 }),
                animate(500)
            ]),
            transition(":leave", [
                animate(500, style({ opacity: 0 }))
            ])
        ]),
    ],
    standalone: false
})

export class ChangePlanComponent implements OnInit {
  @ViewChild('stickyElement') stickyElement!: ElementRef;
  stickyPosition: number = 0;
  // Hero Information
  heroData: any = {};
  showHero = false;
  currentPlan: ProductChange;
  othersPlans: ProductChange[];
  paymentMethodsImages = ["mastercard.png", "visa.png", "elo.png",
    "hipercard.png", "american-express.png",
    "diners-club.png", "discover.png", "boleto.png", "pix.png"]
  innerWidth: number;
  onMobile: boolean;
  coupon: any;
  userId: any;
  businessId: any;
  ref: string;
  internalReference: any;
  checksum: any;
  checksumData: { ref: any; internalReference: any; cs: any; };
  swiperButtonNext: any;
  packages: any;
  redirectUrl: string;
  paymentForm: any;
  contractErrorData: any;
  showPaymentForm: any;
  classificationName: any;
  showErrorHero: boolean;
  classificationIdentifier: any;

  selectedPackage: ShopWindowItem;
  filteredUpgradeCurrentProduct: ShopWindowItem;
  periodicity: Array<string> = [];
  yearlyPlans: Array<ShopWindowItem> = [];
  monthlyPlans: Array<ShopWindowItem> = [];
  trimestralPlans: Array<ShopWindowItem> = [];
  semestralPlans: Array<ShopWindowItem> = [];
  allProducts: Array<ProductChange> = [];
  plans: Array<ShopWindowItem> = [];
  packageIndex: number = 0;
  biggerDiscountAplied: string;
  hasAnyCoupon: boolean = false;
  packagesLenght: number;
  sliderPackages: Array<ShopWindowItem> = [];
  someoneHasDiscountFloatBadge: boolean = false;
  hasSelectedPackage: boolean = false;
  filteredUpgradeProducts: Array<ShopWindowItem> = [];

  constructor(
    private customerService: CustomerService,
    public catalogService: CatalogService,
    private discountModalService: DiscountModalService,
    private route: ActivatedRoute,
    private router: Router,
    private sessionStorageService: SessionStorageService,
    public dtmService: DtmService,
    public dialog: MatDialog,
    private elementRef: ElementRef) {

    this.openDialogSpinner();

    // Gambs para funcionar adobe analytics customizado
    this.innerWidth = window.innerWidth;
    this.onMobile = this.innerWidth <= 960;

    if (!this.sessionStorageService.isReloading()) {
      localStorage.removeItem('checkoutSuccessData');
      this.sessionStorageService.resetSessionStorage();
    }

    // this.sessionStorageService.clearSessionStorage(
    //   ['category', 'product', 'identificacaoCompleted', 'pagamentoCompleted', 'sucessoCompleted', 'name', 'email', 'cart', 'customer']);

    this.sessionStorageService.clearSessionStorage()

    // Gets the UserID and BusinessId from SessionStorage
    this.getProvisioningParametersFromSessionStorage();
    this.route.paramMap.subscribe((params) => {
      this.classificationIdentifier = params.get('classificationIdentifier');
    });

    this.route.queryParams.subscribe((params) => {
      this.coupon = params.coupon;
      if (this.coupon) {
        sessionStorage.setItem('coupon', this.coupon);
      }
      if (params.userId && params.businessId) {
        this.userId = params.userId;
        this.businessId = params.businessId;
        this.setProvisioningParametersOnSessionStorage();
      }

      if (params.redirectUrl) {
        sessionStorage.setItem('successRedirectUrl', params.redirectUrl);
        this.redirectUrl = params.redirectUrl;
      }

      // Obtem parametros de checksum
      if (params.cs) {
        if (params.ref) {
          try {
            // Obtem user e business id do parametro ref em base64
            this.ref = atob(params.ref);
            const [refUserId, refBusinessId] = this.ref.split(':');

            if (refUserId) {
              this.userId = refUserId;
            }
            if (refBusinessId) {
              this.businessId = refBusinessId;
            }
            this.setProvisioningParametersOnSessionStorage();
          } catch (err) { }
        }

        if (params.internalReference) {
          this.internalReference = params.internalReference;
        }

        this.checksum = params.cs;
        this.checksumData = {
          ref: this.ref,
          internalReference: this.internalReference,
          cs: this.checksum
        };

        // Remove query params
        this.router.navigate([], {
          queryParams: {
            'cs': null,
            'ref': null,
            'internalReference': null
          },
          queryParamsHandling: 'merge'
        });
      }
    });

    this.classificationIdentifier = this.classificationIdentifier || this.sessionStorageService.getClassification();

    this.catalogService.getProductsForChangePlan(
      this.userId,
      this.sessionStorageService.getClassification(),
      this.businessId,
      'upgrade'
    ).subscribe(
      (products: Array<ProductChange>) => {
        // Aqui você tem acesso ao resultado da chamada
        this.allProducts = products;
        this.currentPlan = products.find((product) => product.currentPlan);
        this.othersPlans = products.filter((product) => !product.currentPlan).map(
          (product) => {
            product.planName = product.planName.split('- ')[1];
            return product;
          }
        );
        this.othersPlans = this.othersPlans.sort((a, b) => a.planValue - b.planValue);
        this.currentPlan.planFullName = {...this.currentPlan}.planName;//clone
        this.currentPlan.planName = this.currentPlan.planName.split('- ')[1];
        this.getShopWindowProducts();

        if (this.othersPlans.length === 0) {
          this.showHero = true;
          this.heroData.type = 'info';
          this.heroData.title = 'Upgrade máximo alcançado!';
          this.heroData.contents = ['Parece que você já está aproveitando nosso plano máximo. Não há mais planos de upgrade, pois você já desfruta de todos os benefícios disponíveis. Estamos à disposição para qualquer dúvida. Obrigado por escolher nossos serviços!'];
        }

      },
      (error) => {
        this.showCustomError('authenticationError', error);
      }
    );
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    // Gambs para funcionar adobe analytics customizado
    this.innerWidth = event.target.innerWidth;
    this.onMobile = this.innerWidth <= 960;
  }

  ngAfterViewInit(): void {
    if (this.stickyElement) {
      this.stickyPosition = this.stickyElement.nativeElement.offsetTop;
    }
    this.dtmService.pageLoaded(Dtm.VitrineUpgrade, this.sessionStorageService.getIsLogged(), getDtm(Dtm.VitrineUpgrade, this.classificationIdentifier));

    // this.discountModalService.discountModalConfig.subscribe((newDiscountModalConfig) => {
    //   try {
    //     let discountModalConfig = JSON.parse(newDiscountModalConfig);
    //     if (discountModalConfig && discountModalConfig.timeToActivateShopWindow) {
    //       setTimeout(() => {
    //         //Impede o cenário que o cliente navegou para o pagamento sem ter ficado os 30 segundos na vitrine
    //         if (this.router.url.indexOf('meu-pacote') > -1) {
    //           this.discountModalService.setReachedTheModalTime(true);
    //         }

    //       }, discountModalConfig.timeToActivateShopWindow * 1000);
    //       //verificar f5 comportamento do reachedTheTimeModal
    //     }
    //   } catch (err) { }

    // });
  }

  getShopWindowProducts() {
    const validatedMitigation = this.sessionStorageService.getValidatedMitigation();
    this.catalogService
    .getUpgradeProductsByClassification(this.classificationIdentifier, this.userId, validatedMitigation, this.coupon, this.businessId, this.checksumData)
    .subscribe(
      (shopWindow) => {
        this.sessionStorageService.setValidatedMitigation(shopWindow.validatedMitigation);
        if (shopWindow.invalidCS) {
          this.sessionStorageService.resetSessionStorage(true);
          this.openErrorDialog('checksum', "meu-plano");
        } else if (shopWindow.shopWindowItems) {

          const indexPreferred = shopWindow.shopWindowItems.map(el => el.preferred && !el.disable).indexOf(true);
          this.plans = shopWindow.shopWindowItems;
          this.plans.forEach(plan => {
            let periodicityValue = plan.product.periodicity;
            if (!this.periodicity.includes(periodicityValue)) {
              this.periodicity.push(periodicityValue);
            }
          });

          this.monthlyPlans = this.plans.filter((plan) => plan.product.periodicity === "Mensal");
          this.trimestralPlans = this.plans.filter((plan) => plan.product.periodicity === "Trimestral");
          this.semestralPlans = this.plans.filter((plan) => plan.product.periodicity === "Semestral");
          this.yearlyPlans = this.plans.filter((plan) => plan.product.periodicity === "Anual");

          // console.log("Planos Mensais: " + JSON.stringify(this.monthlyPlans, null, 2));
          // console.log("Planos Trimestrais: " + JSON.stringify(this.trimestralPlans, null, 2));
          // console.log("Planos Semestrais: " + JSON.stringify(this.semestralPlans, null, 2));
          // console.log("Planos Anuais: " + JSON.stringify(this.yearlyPlans, null, 2));

          this.checkMonitorePlan();

          if (this.classificationIdentifier === "plano-mensal") {
            this.packages = shopWindow.shopWindowItems;
            const periodicityOrder = ["Mensal", "Trimestral", "Semestral", "Anual"];

            this.packages.sort((a, b) => {
              if (a.product.identifier === this.currentPlan.planIdentifier) {
                return -1;
              }
              if (b.product.identifier === this.currentPlan.planIdentifier) {
                return 1;
              }
              return periodicityOrder.indexOf(a.product.periodicity) - periodicityOrder.indexOf(b.product.periodicity);
            });

            this.getMaxFeatureListIndex(this.packages);
            this.biggerDiscountAplied = this.getBiggerDiscount(this.packages);
            this.getFilteredUgradeProducts();
            // this.packages.forEach(pckg => {
              //   pckg.featureList = pckg.featureList.slice(3);
              //   pckg.monitoringFeatureList = pckg.featureList.slice(-2);
              //   pckg.featureList = pckg.featureList.slice(0, -2);
              // });

            this.hasAnyCoupon = this.packages.some((pckg) =>
              pckg.appliedDiscounts && pckg.appliedDiscounts.length
            );

            this.packagesLenght = this.packages.length;

            this.sliderPackages = [...this.packages];

            if (indexPreferred !== -1) {
                this.sliderPackages.splice(indexPreferred, 1);
                this.sliderPackages.unshift(this.packages[indexPreferred]);
            }

            const enabledProducts = this.packages.filter(el => !el.disable);

          } else {
            this.plans.forEach(plan => {
              if (this.someoneHasDiscountFloatBadge === false && plan.mapPaymentMethodAndDiscount[0]["CREDIT_CARD"].length > 0) {
                this.someoneHasDiscountFloatBadge = true;
              }
            });
          }

          this.dtmService.productsLoaded(
            this.plans.map((plan) => (
              {
                'classificationName': plan.product.classificationName,
                'identifier': plan.product.identifier
              }
            ))
          );

          this.closeDialogSpinner();
          let isVendaDeslogada: any;
          isVendaDeslogada = sessionStorage.getItem("vendaDeslogada");

          if (!isVendaDeslogada) {
            isVendaDeslogada = this.sessionStorageService.getIsLogged();
          } else {
            isVendaDeslogada = isVendaDeslogada && isVendaDeslogada !== "true";
          }

          this.dtmService.customLoaded([]);
          this.dtmService.pageLoaded(Dtm.VitrineUpgrade, isVendaDeslogada, getDtm(Dtm.VitrineUpgrade, this.classificationIdentifier));
          this.dtmService.customLoaded(['ProdImpression', 'OverlayImpression']);
          this.dtmService.ruleChange('ProdImpression');
          this.dtmService.sendPageLoadEvent('ProdImpression');
        }
      },
      (error) => {
        this.handleRequestError('getProductCatalogByCategory', error);
      },
      () => {
      }
    );
  }

  formatCurrency(value: number) {
    let valueString = String(value).replace(".", ",");
    let finalValue = valueString.includes(",") ? valueString.substr(0, valueString.indexOf(",")) : valueString;

    if (valueString.includes(',')) {
      finalValue += valueString.substr(valueString.indexOf(",")) + (valueString.substr(valueString.indexOf(",")).length === 2 ? "0" : "");
    }

    return finalValue;
  }

  getFilteredUgradeProducts() {
    const identifierUpgradedProducts = [];

    this.allProducts.forEach((product) => {
      identifierUpgradedProducts.push(product.planIdentifier);
    });

    const filteredPackages = this.packages.filter((product) =>
      identifierUpgradedProducts.includes(product.product.identifier)
    );
    this.filteredUpgradeProducts = filteredPackages;

    this.filteredUpgradeCurrentProduct = this.filteredUpgradeProducts.find((product) => product.product.identifier === this.currentPlan.planIdentifier);
  }

  getValuesBasedOnFeatureList(featureList: any[], product: any) {
    let values = [];
    const mainFeatureList = featureList.map((feature) => feature.name);

    mainFeatureList.forEach((mainFeatureName) => {
      const matchingProductFeature = product.featureList.find(
        (productFeature) => productFeature.name === mainFeatureName
      );

      if (matchingProductFeature) {
        const value = matchingProductFeature.toValue ?? matchingProductFeature.fromValue;
        values.push(value);
      } else {
        values.push(null);
      }
    });

    return values;
  }

  handleRequestError(request: string, err: any) {
    let errJson = err.error;
    try {
      if (typeof errJson === 'string') {
        errJson = JSON.parse(errJson);
      }
    } catch (e) {
    }

    let errorDetail = errJson.generalMessages.map((errorMessage: any) => errorMessage.text);

    if (errorDetail.includes("SHOP_WINDOW_BLOCKED_USER")) {
      this.openErrorDialog("mitigated", "meu-plano");
    } else {
      this.dtmService.customErrorLoaded(['error'], {
        errorDetail: JSON.stringify(errorDetail),
        errorMessage: 'Não foi possível buscar os catálogo de produtos. Tente novamente mais tarde',
      });
    }
  }

  getBiggerDiscount(packages: Array<ShopWindowItem>) : string {
    let apliedDiscounts : Array<string> = [];
    let sumDiscounts = (discounts: Array<Discount>) => {
      return discounts.reduce(
        (accumulator, currentValue) => accumulator + Number(currentValue.deal.slice(0,2)),
      0,) + "%";
    }
    packages.forEach((item: ShopWindowItem) => {
      if(item.appliedDiscounts && item.appliedDiscounts.length > 0) apliedDiscounts.push(sumDiscounts(item.appliedDiscounts));
    });
    return (apliedDiscounts && apliedDiscounts.length > 0)?
    apliedDiscounts.sort((a,b) => {return Number(b.slice(0,2)) - Number(a.slice(0,2))})[0]: null;
  }

  getMaxFeatureListIndex(packages: any[]){
    let maxFeatureListLength = 0;
    packages.forEach((pckg) => {
      if(pckg.featureList.length > maxFeatureListLength){
        maxFeatureListLength = pckg.featureList.length;

        this.packageIndex = packages.indexOf(pckg);
      }
    });
  }

  checkMonitorePlan() {
    this.customerService.getContractStatusByProvisioningParameters(this.businessId, this.userId, "monitore-clientes").subscribe(
      (result) => {
        if (result) {
          if (result.product.classification === "monitore-clientes" && result.contractStatus === "ACTIVE") {
            this.removePremiumPlus();

          }
        }
      }
    );
  }

  removePremiumPlus() {
    this.plans = this.plans.filter((plan) => plan.product.identifier !== "saude-do-seu-negocio-premium-plus-anual-2");
  }

  ngDoCheck() {
    if (!this.swiperButtonNext) {
      this.swiperButtonNext = (<HTMLElement>this.elementRef.nativeElement).querySelector(".swiper-button-next")

      if (this.swiperButtonNext)
        this.swiperButtonNext.classList.add("wiggly")
    }
  }

  handleProductsLoadDtm() {
    if (!this.onMobile) {
      this.dtmService.productsLoaded(
        this.packages.map((plan) => (
          { 'classificationName': plan.product.classificationName, 'identifier': plan.product.identifier }))
      );

      this.dtmService.customLoaded(['ProdImpression', 'OverlayImpression']);
      this.dtmService.ruleChange('ProdImpression');
      this.dtmService.sendPageLoadEvent('ProdImpression');
    } else {
      //TODO Verificar se usaremos o directiveRef para a navegação entre pacotes mobile
      // this.directiveRef.config.autoplay = {
      //   delay: 0
      // };
      // this.directiveRef.startAutoplay();
    }
  }

  openDialogSpinner(): void {
    this.closeDialogSpinner();
    this.dialog.open(LoadingComponent, {
      disableClose: true,
      width: '400px',
      panelClass: 'pme-dialog-loading-panel',
      backdropClass: 'pme-dialog-loading-backdrop'
    });
  }

  private closeDialogSpinner() {
    this.dialog.closeAll();
  }

  getProvisioningParametersFromSessionStorage() {
    this.userId = this.sessionStorageService.getUserId();
    this.businessId = this.sessionStorageService.getBusinessId();

    if (!this.userId || !this.businessId) {
      this.sessionStorageService.setIsLogged(false);
    } else {
      this.sessionStorageService.setIsLogged(true);
    }
  }

  setProvisioningParametersOnSessionStorage() {
    this.sessionStorageService.setUserIdAndBusinessId(this.userId, this.businessId);

    if (this.userId && this.businessId) {
      this.sessionStorageService.setIsLogged(true);
    }
  }

  ngOnInit(): void {
    this.openDialogSpinner();
    this.dtmService.customLoaded([]);
    this.dtmService.pageLoaded(Dtm.VitrineUpgrade, this.sessionStorageService.getIsLogged(), getDtm(Dtm.VitrineUpgrade, this.classificationIdentifier));
    this.dtmService.userLoaded({
      userId: this.userId,
      businessId: this.businessId
    });

    this.dtmService.sendPageLoadEvent();
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const element = document.querySelectorAll(".sticky-element-assinatura");

    const windowScroll = window.pageYOffset;
    const windowWidth = window.innerWidth;
    if (windowScroll > this.stickyPosition + 330 && windowWidth > 1280) {
      this.stickyElement.nativeElement.classList.add("fixed");
      element.forEach((element: any) => {
        element.style.position = "fixed";
      });
    } else {
      this.stickyElement.nativeElement.classList.remove("fixed");
      element.forEach((element: any) => {
        element.style.position = "relative";
      });
    }
  }

  onSwipe() {
    this.swiperButtonNext.classList.remove("wiggly");
  }

  showCustomError(customErrorKey: string, integrationError?: any) {
    let integrationErrorMessage: any;

    switch (customErrorKey) {
      case 'termOfUsedIntegrationError':
        this.paymentForm.addValidationError(errorMapping[customErrorKey]);
        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: errorMapping[customErrorKey],
          errorMessage: errorMapping[customErrorKey],
        });
        this.closeDialogSpinner();
        break;
      case 'invalidPaymentOption':
        this.paymentForm.addValidationError(errorMapping[customErrorKey]);

        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: 'PaymentOptionInválido',
          errorMessage: errorMapping[customErrorKey],
        });
        this.closeDialogSpinner();
        break;
      case 'getPlansAvailableForUpgradeError':
        console.error(integrationErrorMessage);

        if (integrationError && integrationError.error) {
          const error = integrationError.error;
          const SUSPENDED_ERROR_CODES = ['SUSPENDED_EXPIRED_BILLET', 'SUSPENDED_BANK_BILLET', 'SUSPENDED_CREDIT_CARD'];
          const isSuspended = error.generalMessages.some(msg => SUSPENDED_ERROR_CODES.indexOf(msg.code) > -1);
          const isPending = error.generalMessages.some(msg => msg.code === 'PENDING');

          const invoiceIsPending = error.generalMessages.some(msg => msg.code === 'PENDING_INVOICE');
          const invoiceIsExpired = error.generalMessages.some(msg => msg.code === 'EXPIRED_INVOICE');

          const creditCardInvoicePending = error.generalMessages.some(msg => msg.code === 'CREDIT_CARD_PENDING_INVOICE');
          const creditCardInvoiceIsExpired = error.generalMessages.some(msg => msg.code === 'CREDIT_CARD_EXPIRED_INVOICE');

          if (isPending) {
            this.contractErrorData.isPending = true;
            integrationErrorMessage = this.showCustomHeroError(integrationError, 'contractPendingError');

          } else if (invoiceIsPending) {
            this.contractErrorData.isInvoicePending = true;
            integrationErrorMessage = this.showCustomHeroError(integrationError, 'invocePendingError');

          } else if (creditCardInvoicePending) {
            this.contractErrorData.isCreditCardInvoicePending = true;
            integrationErrorMessage = this.showCustomHeroError(integrationError, 'creditCardInvoicePendingError');

          } else if (creditCardInvoiceIsExpired) {
            this.contractErrorData.isCreditCardInvoicePending = true;
            integrationErrorMessage = this.showCustomHeroError(integrationError, 'creditCardInvoiceIsExpiredError');

          } else if (invoiceIsExpired) {
            this.contractErrorData.isInvoiceExpired = true;
            integrationErrorMessage = this.showCustomHeroError(integrationError, 'invoceExpiredError');

          } else if (isSuspended) {
            // Se o erro de integracao pro upgrade foi por causa do status do contrato
            this.contractErrorData.isSuspended = true;

            error.generalMessages.forEach(msg => {
              if (msg.code === 'SUSPENDED_BANK_BILLET') {
                this.contractErrorData.isBankBillet = true;
              } else if (msg.code === 'SUSPENDED_EXPIRED_BILLET') {
                this.contractErrorData.isBankBillet = true;
                this.contractErrorData.isBankBilletExpired = true;
              }
            });
            integrationErrorMessage = this.showCustomHeroError(integrationError, 'contractSuspendedError');
          } else {
            integrationErrorMessage = this.showCustomHeroError(integrationError, 'getPlansAvailableForUpgradeError');
          }
        }
        // integrationErrorMessage = this.showCustomHeroError(integrationError, 'getPlansAvailableForUpgradeError');


        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        this.closeDialogSpinner();
        break;
      case 'upgradeError':
        integrationErrorMessage = this.handleUpgradeError(integrationError);

        if (['WATCHLIST_INVESTIGATE', 'WATCHLIST_REJECT_CREDITCARD', "WATCHLIST_REJECT_BOLETO", "WATCHLIST_REJECT_PIX", 'MODAL_WATCHLIST_PENDING_PURCHASE'].indexOf(integrationErrorMessage.userMessage) >= 0) {
          this.openErrorDialog(integrationErrorMessage.userMessage);
        } else {
          this.paymentForm.addValidationError(integrationErrorMessage.userMessage);
          console.error(integrationErrorMessage);
          this.closeDialogSpinner();
        }
        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        break;
      case 'authenticationError':
        integrationErrorMessage = this.showCustomHeroError(integrationError, 'authenticationError');
        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        this.closeDialogSpinner();
        break;
      default:
        break;
    }
    if (this.showPaymentForm) {
      this.paymentForm.submitting = false;
      this.paymentForm.enableFields('all');
    }
  }

  openErrorDialog(dialogData: string, errorDetail?: string, errorMessage?: string) {
    let data = DialogData.fromPreset(dialogData, {
      classificationName: this.classificationName,
      businessId: this.businessId,
      userId: this.userId
    });

    let dialogRef = this.dialog.open(DialogAlertComponent, {
      disableClose: true,
      panelClass: 'pme-dialog-alert-panel',
      autoFocus: false,
      data: data
    });
  }

  handleUpgradeError(error: any): any {
    let resultError: any = {};

    try {
      if (typeof error === "string") {
        error = JSON.parse(error);
      }

      if (error.status && error.error) {
        resultError.status = error.status;
        resultError.endpoint = error.url;
        resultError.name = error.name;

        resultError.handledError = !!error.error._messages.filter((message) => {
          return message.code !== null;
        });

        resultError.errors = error.error._messages.filter((message) => {
          return message.type === "ERROR";
        });

        resultError.warnings = error.error._messages.filter((message) => {
          return message.type === "WARNING";
        });

        let parseObj;
        try {
          parseObj = JSON.parse(resultError.errors[0].text);
        } catch (err) { }

        if (parseObj && parseObj.context !== undefined) {
          resultError.context = parseObj.context;
          resultError.userMessage = parseObj.message;
          resultError.errorCode = resultError.errors[0].code || parseObj.code;
          resultError.errors[0].text = resultError.userMessage;
        } else {
          resultError.userMessage = resultError.errors[0].text;
          resultError.errorCode = resultError.errors[0].code;
        }

        // Nova errorString
        resultError.errorString = (resultError.context || "SYDLE") + ":CODE:" + error.status + ":HTTP:" + (resultError.errorCode || resultError.status) + ":POST/" + resultError.endpoint + ":" + JSON.stringify(resultError.errors.map(({ text }) => text));

        /*resultError.errorString = `${resultError.status}:${resultError.name}:${resultError.endpoint}:${JSON.stringify(resultError.errors)}:${JSON.stringify(resultError.warnings)}`;*/

        if (braspagReasonCode[resultError.userMessage]) {
          resultError.userMessage = braspagReasonCode[resultError.userMessage];
        } else if (adyenReasonCode[resultError.userMessage]) {
          resultError.userMessage = adyenReasonCode[resultError.userMessage];
        } else if (resultError.userMessage.indexOf('java') >= 0 ||
          resultError.userMessage.indexOf('Java') >= 0 ||
          resultError.userMessage.indexOf("Script") >= 0 ||
          resultError.userMessage.indexOf("script") >= 0 ||
          resultError.userMessage.indexOf('elastic') >= 0 ||
          resultError.userMessage.indexOf('Elastic') >= 0) {
          resultError.userMessage = "Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.";
        } else if (!(resultError.userMessage.indexOf('WATCHLIST_REJECT') >= 0)) {
          resultError.userMessage = "Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.";
        } else {
          resultError.userMessage = "Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.";
        }

      }
    } catch (e) {
      resultError.errorString = JSON.stringify(error);
      resultError.userMessage = "Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.";
    }

    return resultError;
  }

  showCustomHeroError(error, type) {
    const resultError: any = {};
    let isSuspendedError = false;
    let isInvocePendingError = false;
    let isInvoceExpiredError = false;
    let isCreditCardInvoceError = false;

    try {
      if (typeof error === 'string') {
        error = JSON.parse(error);
      }

      if (error.status && error.error) {
        resultError.status = error.status;
        resultError.endpoint = error.url;
        resultError.name = error.name;

        resultError.handledError = !!error.error._messages.filter((message) => {
          return message.code !== null;
        });

        resultError.errors = error.error._messages.filter((message) => {
          return message.type === 'ERROR';
        });

        resultError.warnings = error.error._messages.filter((message) => {
          return message.type === 'WARNING';
        });

        // Nova errorString
        resultError.errorString = (resultError.context || "SYDLE") + ":CODE:" + error.status + ":HTTP:" + (resultError.errorCode || resultError.status) + ":POST/" + resultError.endpoint + ":" + JSON.stringify(resultError.errors.map(({ text }) => text));

        /*resultError.errorString = `${resultError.status}:${resultError.name}:${resultError.endpoint}:${JSON.stringify(resultError.errors)}:${JSON.stringify(resultError.warnings)}`;*/

        resultError.userMessage = error.error._messages[0].text;
        resultError.code = error.error._messages[0].code;
        switch (type) {
          case 'authenticationError':
            if (authReasonCode[resultError.code]) {
              this.heroData.type = 'error';
              this.heroData.title = authReasonCode[resultError.code].title;
              this.heroData.contents = authReasonCode[resultError.code].contents;
            } else {
              this.heroData.type = 'error';
              this.heroData.title = 'Serviço indisponível!';
              this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.'];
            }

            break;
          case 'paymentChangeDataError':
            // TODO - Implementar para Erros desta pagina
            this.heroData.type = 'error';
            this.heroData.title = 'Serviço indisponível!';
            this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.'];
            break;
          case 'contractPendingError':
            this.heroData.type = 'error';
            this.heroData.title = 'Seu contrato está pendente!';
            this.heroData.contents = ['Seu contrato está pendente. Aguarde seu contrato ser ativado, e tente novamente!'];
            break;
          case 'contractSuspendedError':
            this.heroData.type = 'error';
            this.heroData.title = 'Seu contrato está suspenso!';
            this.heroData.contents = ['Seu contrato foi suspenso. Normalize a sua situação para realizar um upgrade de plano!'];
            isSuspendedError = true;
            break;
          case 'invocePendingError':
            this.heroData.type = 'error';
            this.heroData.title = 'Fatura em aberto!';
            this.heroData.contents = ['Seu contrato possui uma fatura em aberto. Normalize a sua situação para realizar um upgrade de plano!'];
            isInvocePendingError = true;
            break;
          case 'creditCardInvoicePendingError':
            this.heroData.type = 'error';
            this.heroData.title = 'Fatura em aberto!';
            this.heroData.contents = ['Seu contrato possui uma fatura em aberto. Normalize a sua situação para realizar um upgrade de plano!'];
            isCreditCardInvoceError = true;
            break;
          case 'invoceExpiredError':
            this.heroData.type = 'error';
            this.heroData.title = 'Fatura vencida!';
            this.heroData.contents = ['Seu contrato possui uma fatura vencida que não foi paga. Normalize a sua situação para realizar um upgrade de plano!'];
            isInvoceExpiredError = true;
            break;
          case 'creditCardInvoiceIsExpiredError':
            this.heroData.type = 'error';
            this.heroData.title = 'Fatura vencida!';
            this.heroData.contents = ['Seu contrato possui uma fatura vencida que não foi paga. Normalize a sua situação para realizar um upgrade de plano!'];
            isCreditCardInvoceError = true;
            break;
          default:
            this.heroData.type = 'error';
            this.heroData.title = 'Serviço indisponível!';
            this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.'];
            break;
        }
      }
    } catch (e) {
      console.error(e);
      resultError.errorString = error.toString();
      this.heroData.type = 'error';
      this.heroData.title = 'Serviço indisponível!';
      this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.'];
    }

    this.heroData.showButton = true;
    this.heroData.buttonName = isSuspendedError || isInvoceExpiredError || isCreditCardInvoceError ? 'Regularizar pagamento' : isInvocePendingError ? 'Gerar segunda via' : 'Voltar';
    this.heroData.redirectURL = sessionStorage.getItem('successRedirectUrl');

    this.showErrorHero = true;
    return resultError;
  }

  swiperConfig: any = {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    watchOverflow: true,
    freeMode: true,
    slidesPerView: "auto",
  };
}
